import axios from "axios";

import config from "../../config";

export async function preSignToS3({ campaignId, resourceName, file }) {
  try {
    const baseURL = config.apiHost;
    const { type, name } = file;

    const targetUrl = "campaign/s3/resource";

    const fileExtension = name.split(".").splice(-1)[0].toLowerCase();

    const fileParams = {
      campaignId,
      resourceName,
      resourceExtension: fileExtension,
      contentType: type,
    };

    const response = await axios.post(`${baseURL}/${targetUrl}`, fileParams);

    if (response.status === 200) {
      return response.data;
    }

    return false;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
    return false;
  }
}

export async function uploadFileToS3({ presignedUrl, file }) {
  try {
    const { type } = file;

    if (!file || file.size < 1000) {
      throw new Error('Invalid file: File is empty or too small');
    }

    await axios.put(presignedUrl.signedUrl, file, {
      headers: {
        'Content-Type': type
      },
      timeout: 300000,
    });

    return presignedUrl;
  } catch (error) {
    window.newrelic && window.newrelic.noticeError('S3_UPLOAD_ERROR', {
      data: error,
      fileSize: file?.size,
      fileName: file?.name
    });
    throw Error(error);
  }
}

export async function createPresignedUrl() {
  try {
    const baseURL = config.apiHost;
    const URL = "/videos/s3/sign";
    const filename = (new Date().getTime()).toString(36);
    const url = `${baseURL}${URL}?objectName=${filename}.mp4&contentType=video/mp4`;
    const response = await axios.get(url, {
      headers: {
        'Content-Type': 'application/json'
      }
    });

    return response.data;
  } catch (error) {
    window.newrelic && window.newrelic.noticeError('S3_PRESIGN_ERROR', {
      data: error,
    });
    throw Error(error);
  }
}

export async function createPresignedUrlVideoMessage(blob, videoId) {
  try {
    const presignedUrl = await preSignToS3({
      campaignId: videoId,
      resourceName: 'videoMessage',
      file: blob,
    });
  
    return presignedUrl;
  } catch (error) {
    window.newrelic && window.newrelic.noticeError('S3_PRESIGN_ERROR', {
      data: error,
    });
    throw Error(error);
  }
}



// WEBPACK FOOTER //
// ./src/components/InputImage/S3Uploader.js